import store from "../../../store";

import onLoad from "../../../store/on-load";
import resolveRoutedVolume from "../../../store/getters/resolve/resolve-routed-volume";
import resolveRoutedSchoolLevel from "../../../store/getters/resolve/resolve-routed-school-level";
import resolveRoutedSeason from "../../../store/getters/resolve/resolve-routed-season";
import autoVolume from "../../../store/getters/auto/auto-volume";
import autoSchoolLevel from "../../../store/getters/auto/auto-school-level";
import autoSeason from "../../../store/getters/auto/auto-season";
import resolveRoutedSeasonContentForSchoolLevel from "../../../store/getters/resolve/resolve-routed-season-content-for-school-level";
import resolveRoutedDay from "../../../store/getters/resolve/resolve-routed-day";
import autoDay from "../../../store/getters/auto/auto-day";

// To be used when day is an auto value.
const redirectToAutoDay = (
  route,
  { parentVolume, parentSeason, parentSeasonContentForSchoolLevel },
  next,
) => {
  const day = autoDay(
    null,
    {
      parentVolume,
      parentSeason,
      parentSeasonContentForSchoolLevel,
    },
    store,
  );

  if (day) {
    // There is a day available in the parent season content for school level
    // (be it routed or auto). We can use that to redirect to the auto day.
    next({
      name: "CalendarSheet",
      params: {
        ...route.params,
        seasonSlug: parentSeason.slug,
        daySlug: day.slug,
      },
      force: true,
    });
    return;
  }

  // We do not have a day to route to.
  // All we can do is display the CalendarSheet component without a matched day.
  next();
};

// A helper function to redirect to a valid route
// when entering or updating routes in the CalendarSheet component.
export default async function ensureValidDay(route, next) {
  await onLoad(store);

  const activeVolume = resolveRoutedVolume(route, store) || autoVolume(store);
  const activeSchoolLevel =
    resolveRoutedSchoolLevel(route, store) || autoSchoolLevel(store);

  const activeSeason =
    resolveRoutedSeason(route, activeVolume, store) ||
    autoSeason(activeVolume, store);
  const activeSeasonContentForSchoolLevel =
    resolveRoutedSeasonContentForSchoolLevel(
      route,
      {
        parentSeason: activeSeason,
        parentSchoolLevel: activeSchoolLevel,
      },
      store,
    );

  const routedDay = resolveRoutedDay(
    route,
    activeSeasonContentForSchoolLevel,
    store,
  );

  if (routedDay) {
    // We have a routed day - which is all we need. Stay here.
    next();
    return;
  }

  // Let's try an auto day, or fail.
  redirectToAutoDay(
    route,
    {
      parentVolume: activeVolume,
      parentSeason: activeSeason,
      parentSeasonContentForSchoolLevel: activeSeasonContentForSchoolLevel,
    },
    next,
  );
}
